export default "__VITE_ASSET__7514e2c7__"